import { User, Sex } from './user.model'

export enum RelationshipType {
  parent,
  partner,
  spouse
}

export class Relationship {
  public userId = ''
  public relatedUser = new User()
  public relationship: RelationshipType = null

  cast (data: Object) {
    Object.keys(data).forEach(key => {
      if (!this.hasOwnProperty(key)) return

      switch (key) {
        case 'relatedUser':
          this[key] = new User().cast(data[key])
          break
        case 'relationship':
          const type: string = data[key]
          this[key] = typeof RelationshipType[type] !== 'undefined' ? RelationshipType[type] : null
          break
        default:
          this[key] = data[key]
      }
    })

    return this
  }

  generateSelectType () {
    return Object.keys(RelationshipType)
      .filter(key => !isNaN(parseInt(key, 10)))
      .map((el, index) => {
        return {
          value: RelationshipType[index],
          label: this.getTypeLabel(index)
        }
      })
  }

  getTypeLabel (label) {
    const type = typeof label !== 'undefined' ? label : this.relationship
    switch (type) {
      case RelationshipType.parent:
      case RelationshipType[RelationshipType.parent]:
        return this.relatedUser.sex === Sex.F ? 'Mère' : (this.relatedUser.sex === Sex.M ? 'Père' : 'Parent')
      case RelationshipType.partner:
      case RelationshipType[RelationshipType.partner]:
        return this.relatedUser.sex === Sex.F ? 'Conjointe' : 'Conjoint'
      case RelationshipType.spouse:
      case RelationshipType[RelationshipType.spouse]:
        return this.relatedUser.sex === Sex.F ? 'Épouse' : 'Époux'
      default:
        return null
    }
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/models/relationship.model.ts